import { getListOfGatewayAndPriceWhatsapp } from "../types/gateway_and_price_list_whatsapp_types";

const initState = {
  data: [],
  loading: false,
  error: null,
};

export default function gatewayAndPriceListWhatsappReducer(state = initState, action = {}) {
  switch (action.type) {
    case getListOfGatewayAndPriceWhatsapp.GET_LIST_OF_GATEWAY_AND_PRICE_WHATSAPP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getListOfGatewayAndPriceWhatsapp.GET_LIST_OF_GATEWAY_AND_PRICE_WHATSAPP_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null,
      };
    case getListOfGatewayAndPriceWhatsapp.GET_LIST_OF_GATEWAY_AND_PRICE_WHATSAPP_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
